import { useEffect, useState } from "react";
import moment from 'moment';
import { t } from "i18next";
import competitionIcon from "../../assets/images/competition.svg";
import competitionWhiteIcon from "../../assets/images/competition-white.svg";
import { Link, useNavigate } from "react-router-dom";
import { getCompetitions } from "../../services/competition";
import 'moment/locale/es';
import { LoadingSpinner } from "../general/loading-spinner";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import esLocale from '@fullcalendar/core/locales/es';
import { Competition } from "../../interfaces/competition";
import rrulePlugin from '@fullcalendar/rrule'

export function CompetitionsCalendarBlock() {
    const navigate = useNavigate();
    moment.locale('es');

    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [events, setEvents] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getCompetitions()
            .then(response => {
                setCompetitions(response.data);
                setEvents([
                    ...events,
                    ...response.data.map((c: Competition) => {
                        return {
                            id: c.id.toString(),
                            title: c.name,
                            classNames: ['training'], 
                            color: c.color,
                            // start: moment(c.date_start).format('YYYY-MM-DD'),
                            // startRecur: moment(c.date_start).format('YYYY-MM-DD'),
                            // end: moment(c.date_start).format('YYYY-MM-DD'),
                            // endRecur: moment(c.date_end).format('YYYY-MM-DD'),
                            rrule: {
                                freq: 'daily',
                                interval: 1,
                                dtstart: moment(c.date_start).format('YYYY-MM-DD'), // will also accept '20120201T103000'
                                until: moment(c.date_end).format('YYYY-MM-DD') // will also accept '20120201'
                            },
                            url: '/#/competitions/' + c.id + '/view'
                        }
                    })
                ]);
                setLoaded(true);
            })
            .catch(error => {
                alert(t('connection_expired'));
                localStorage.removeItem('token');
                navigate("/");
            });
    }, []);

    function eventContent(arg: any) {
        /*const handleEventClick = (event: any) => {
            event.preventDefault();
            navigate(arg.event.url);
        }*/
    
        return (<Link className={ arg.event.classNames } to={ arg.event.url } title={ arg.event.title}></Link>);
    }

    return (
        <div className="block block-competition">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ competitionIcon } alt={ t("upcoming_events")} />
                    { t("competitions") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded &&
                        <div className="mini-calendar-container">
                            <FullCalendar
                                plugins={[ rrulePlugin, dayGridPlugin, bootstrap5Plugin ]}
                                initialView="dayGridMonth"
                                weekends={true}
                                firstDay={ 1 }
                                locale={esLocale}
                                height={ 'auto' }
                                events={ events }
                                eventContent= { eventContent }
                            />
                        </div>
                    }

                    { loaded &&
                        <div className="events-list">
                            { 
                                competitions.map((c: Competition) => {
                                    return <div key={ 'competition-' + c.id } className="event-item">
                                            <div className="color-mark" style={{backgroundColor: c.color}}></div>
                                            <div className="name">
                                                <Link to={ '/competitions/' + c.id + '/view' }  title={ c.name }>
                                                    { c.name }
                                                </Link>
                                            </div>
                                            <div className="date">{ c.date_description }</div>
                                            <div className="venue">{ c.venue_name }</div>
                                        </div>;
                                })
                            }
                        </div>
                    }
                </div>
                <div className="block-footer">
                    <Link to="/competitions-events" title={ t("competitions") } className="btn btn-primary">
                        <img src={ competitionWhiteIcon } alt={ t("competitions")} /> { t("competitions") }
                    </Link>
                </div>
            </div>
        </div>
    );
}  
